import { FC, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/auth.context.tsx';
import { Paths } from '../constants/paths.ts';
import { LoadingBackdrop } from '../components/loading.backdrop.tsx';

export const AuthGuard: FC = () => {
  const navigate = useNavigate();
  const { isInitialized: authInit, accessToken, refreshToken } = useAuth();

  useEffect(() => {
    if (!authInit) {
      return;
    }

    if (!accessToken || !refreshToken) {
      return navigate(Paths.LOGIN);
    }
  }, [authInit, navigate, accessToken]);

  if (!authInit) {
    return <LoadingBackdrop />;
  }

  return <Outlet />;
};
